import { gql } from 'graphql-tag';

export const ENRICHED_SAVED_PROPERTY_IDS_QUERY = gql`
    query getEnrichedSavedPropertyIds {
        enrichedSavedPropertyIds {
            ... on EnrichedSavedPropertyIdsSuccess {
                enrichedSavedPropertyIds {
                    category
                    listingId
                    publicationStatus
                    savedDate
                    section
                    lifeCycleStatus
                }
            }

            ... on EnrichedSavedPropertyIdsFail {
                errorCode
            }
        }
    }
`;
